import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { App } from './App'
import reportWebVitals from './reportWebVitals'
import { projectView } from './project-view/project-view'
import 'core-js/features/array/flat-map'
import './index.css'

if (process.env.REACT_APP_ENVIRONMENT !== 'dev')
  Sentry.init({
    enabled: Boolean(process.env.REACT_APP_SENTRY_DSN),
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.05,
  })

void projectView.init()

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
